import { apiPaths } from "@/lib/api/paths";
import type { OkResponse } from "@typings/api";
import { apiClient } from "@/lib/api/client";
import type { CreateTaxonomicGroupDTO } from "./type";

export async function createTaxonomicGroup(
  taxonomicGroup: CreateTaxonomicGroupDTO,
): Promise<OkResponse> {
  const response = await apiClient.post<OkResponse>(
    apiPaths.taxonomicGroups.create,
    taxonomicGroup,
  );
  return response.data;
}
